import { GridActionsCellItem, type GridRowParams } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import type { WaMessageSetup } from "features/waMessaging/types";
import { useWaMessageSetupContext } from "./WaMessageSetupProvider";

const useRowActions = () => {
    const { openEdit } = useWaMessageSetupContext();

    return ({ row }: GridRowParams<WaMessageSetup>) => [
        <GridActionsCellItem
            key='edit'
            onClick={() => openEdit(row)}
            icon={<EditIcon />}
            label='Edit'
            data-test-id={`waMessagesSetups.table.row.${row.coreId}.actions.edit`}
        />,
        <GridActionsCellItem
            key='delete'
            onClick={() => { /* not implemented yet */ }}
            icon={<DeleteForeverIcon />}
            label='Delete'
            data-test-id={`waMessagesSetups.table.row.${row.coreId}.actions.delete`}
        />
    ];
};

export default useRowActions;
